import {PersonnelVI} from "./personnel/vi";
import {AssetVI} from "./assest/vi";
import {WageVI} from "./wage/vi";
import {TimeKeepingVI} from "./timekeeping/vi";
import {ApplicationVI} from "./application/vi";

export const HrmVI = {
    ...PersonnelVI,
    ...AssetVI,
    ...WageVI,
    ...TimeKeepingVI,
    ...ApplicationVI
}